import type { SessionTranslations } from "../../types/session";

export const session: SessionTranslations = {
  expired: "Your session has expired",
  expiresSoon: "Your session will expire soon",
  stayLoggedIn: "Stay Logged In",
  logout: "Logout",
  timeRemaining: "Time remaining",
  timeoutWarningTitle: "Session Timeout Warning",
  timeoutWarningMessage:
    "Your session is about to expire due to inactivity. Please click 'Stay Logged In' to continue working.",
  timeoutCountdown: "{seconds} seconds remaining",
  logoutNow: "Logout Now",
};
